import { render, staticRenderFns } from "./XTextField.vue?vue&type=template&id=3467bd15&scoped=true"
import script from "./XTextField.vue?vue&type=script&lang=js"
export * from "./XTextField.vue?vue&type=script&lang=js"
import style0 from "./XTextField.vue?vue&type=style&index=0&id=3467bd15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467bd15",
  null
  
)

export default component.exports